// Loading-state fallback only; the real license total comes from the spotlight overview endpoint.
export const RAB_LICENSES = 7;

// V1 engine modes are DOM + Rent only. GEO (region-scoped optimization) is deferred to V1.5/V2;
// when it returns it brings its own region selector as an engine parameter. The Scope control here
// is a pure view filter (narrows displayed rows), not an engine input.
export type OptimizerId = 'dom' | 'rent';

export type OptimizerDef = {
  id: OptimizerId;
  label: string;
  description: string;
};

export const OPTIMIZERS: Record<OptimizerId, OptimizerDef> = {
  dom: {
    id: 'dom',
    label: 'Days on market',
    description: 'Prioritize vacancies that have been listed the longest.',
  },
  rent: {
    id: 'rent',
    label: 'Rent',
    description: 'Prioritize the highest rent vacancies.',
  },
};

export const OPTIMIZER_LIST = Object.values(OPTIMIZERS);
